import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled, { css } from 'styled-components/macro';

export const ScModalSelect = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.84)};
  backdrop-filter: ${({ theme }) => theme.secondaryBackdropFilter2};
  z-index: 1111;
  display: flex;
  flex-direction: column;
  overscroll-behavior: contain;
`;

export const ScModalSelectHeader = styled.div`
  margin-top: auto;
  position: relative;

  .header {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 64px 8px 12px;
    margin: 12px 0;

    & > .icon {
      margin-right: 8px;
    }

    & > .title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      font-size: 18px;
      line-height: 1.33;
      letter-spacing: 0.01em;
      color: ${({ theme }) => theme.whiteColor};
    }
  }
`;

export const ScSelectSearchMob = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 24px;
  padding-inline: 8px;
  input {
    outline: none;
    border: none;
    background-color: transparent;
    width: 100%;
    min-width: 0;
    height: 28px;
    color: ${({ theme }) => theme.whiteColor};
    font-size: 16px;
    line-height: 28px;
    -webkit-text-fill-color: initial;

    &::placeholder {
      color: ${({ theme }) => theme.grayColor1};
    }
  }

  .divider {
    width: 100%;
    background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    margin: 8px auto 0;
    height: 2px;
    background: ${({ theme }) => theme.grayColor6};
    border-radius: 1px;
  }

  input:focus ~ .divider {
    background-color: ${({ theme }) => theme.greenColor};
  }
`;

export interface ScModalSelectBodyProps {
  borderBottom?: boolean;
  fullHeight?: boolean;
}

export const ScModalSelectBody = styled.div<ScModalSelectBodyProps>`
  width: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  position: relative;
  background-color: ${({ theme }) => theme.grayColor5};

  ${({ borderBottom }) =>
    borderBottom
      ? css`
          border-radius: 16px;
        `
      : css`
          border-radius: 16px 16px 0 0;
          border-bottom: none;
        `}
  padding: 24px 12px;

  .not-found {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.whiteColor};
  }
  @media (${device.mobile}) {
    ${({ fullHeight }) =>
      fullHeight &&
      css`
        flex: 1 1 auto;
        min-height: 0;
      `}
  }
`;

export const ScModalSelectInner = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

interface ScModalSelectOptionProps {
  roundIcon?: boolean;
  selected?: boolean;
}

export const ScModalSelectOption = styled.button<ScModalSelectOptionProps>`
  display: flex;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  width: 100%;
  min-width: 0;
  height: 52px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding: 10px 8px;
  gap: 12px;
  height: 48px;
  border-radius: 12px;

  ${({ theme, selected }) =>
    selected
      ? css`
          background-color: ${theme.grayColor6};
          border-color: ${theme.grayColor6};
        `
      : css`
          background-color: transparent;
          border-color: transparent;
        `}

  & > .icon {
    display: flex;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      object-fit: cover;
      object-position: center;
      border-radius: ${({ roundIcon }) => (roundIcon ? '50%' : '0px')};
    }
  }
  & > .name {
    font-size: 16px;
    line-height: 1.75;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    ${({ theme, selected }) =>
      selected
        ? css`
            color: ${theme.whiteColor};
          `
        : css`
            color: ${theme.secondaryColor};
          `}
  }

  @media (${device.mobile}) {
    padding: 10px 8px;
    background-color: transparent;
    border: none;
    justify-content: flex-start;

    ${({ theme, selected }) =>
      selected &&
      css`
        background-color: ${theme.secondaryColor2};
        color: ${theme.whiteColor};
        font-weight: 700;
      `}
  }
`;
